module.exports = __webpack_public_path__ + "static/media/(000125).dea2114e.jpg";